import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrganisationService {
  API_SERVER: string = environment.baseApiUrl;
  reloadTable$ = new BehaviorSubject(false);

  constructor(private httpClient: HttpClient) {}

  findAll(params?): Observable<any> {
    let Params = new HttpParams();
    if (params && Object.keys(params).length > 0) {
      params.forEach((elem) => {
        Params = Params.append(elem.key, elem.val);
      });
    }
    return this.httpClient
      .get(this.API_SERVER + 'organisation', { params: Params });
  }

  findOne(id): Observable<any> {
    return this.httpClient
      .get(this.API_SERVER + `organisation/${id}`);
  }

  create(data: IUpdateOrg): Observable<any> {
    return this.httpClient
      .post(this.API_SERVER + 'organisation', data);
  }

  update(id, data: IUpdateOrg): Observable<any> {
    return this.httpClient
      .put(this.API_SERVER + `organisation/${id}`, data);
  }

  remove(id): Observable<any> {
    return this.httpClient
      .delete(this.API_SERVER + `organisation/${id}`);
  }

  restore(id): Observable<any> {
    return this.httpClient
      .delete(this.API_SERVER + `organisation/restore/${id}`);
  }
}

/**
 * Interface for updating/creating organization
 */
export interface IUpdateOrg {
  name: string
  description?: string
  accent_color?: string
  def_lang?: string
  logo_url?: string
  members?: string[]
}
